var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 15,
    viewBox: "0 0 12 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 10.0625V8.3125M2.09375 4.75C2.09375 2.53413 3.76637 0.75 5.84375 0.75C7.13779 0.75 8.27478 1.4423 8.94825 2.5M2.25 5.41667C1.5625 5.41667 1 6.01667 1 6.75V12.6667C1 13.4 1.5625 14 2.25 14H9.75C10.4375 14 11 13.4 11 12.6667V6.75C11 6.01667 10.4375 5.41667 9.75 5.41667H2.25Z",
    stroke: "#825DFC",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlock);
export default __webpack_public_path__ + "static/media/unlock.4a32f993e604033bf6104913f205c37a.svg";
export { ForwardRef as ReactComponent };